export const EMPTY_CART_TEXT = `Ваша корзина пуста`;
